import dayjs from 'dayjs';

export function getLeaseTermDuration(value: string[]) {
  if (value.length !== 2 || value.some(item => !item)) {
    return '';
  }

  const [startDate, endDate] = value;
  const days = dayjs(endDate).startOf('day').diff(dayjs(startDate).startOf('day'), 'day') + 1;

  if (days < 1) {
    return '';
  }

  if (days < 7) {
    return `${days}天`;
  }

  const weeks = Math.floor(days / 7);
  const remainingDays = days % 7;

  return remainingDays ? `${weeks}周${remainingDays}天` : `${weeks}周`;
}
